import { genStyleHook } from '../../tools/style';

export default genStyleHook('array-items', (token) => {
  const {
    componentCls,
    antCls,
    colorBgBase,
    fontSizeSM,
    colorBorder,
    colorText,
    marginXS,
    marginXXS,
    paddingXXS,
    paddingXS,
    borderRadiusSM,
    boxShadowSecondary,
  } = token;

  const itemCls = `${antCls}-formily-item`;
  return {
    [componentCls]: {
      [`${componentCls}-item-inner`]: {
        visibility: 'visible',
      },

      '&-item': {
        zIndex: 100000,
      },

      '&-card': {
        display: 'flex',
        border: `1px solid ${colorBorder}`,
        marginBottom: marginXS,
        padding: `${paddingXXS}px ${paddingXS}px`,
        background: colorBgBase,
        justifyContent: 'space-between',
        color: colorText,
        gap: marginXS,
        flexWrap: 'wrap',

        [`${itemCls}:not(${itemCls}-feedback-layout-popover)`]: {
          marginBottom: '0 !important',

          [`${itemCls}-help`]: {
            position: 'absolute',
            fontSize: fontSizeSM,
            top: '100%',
            background: colorBgBase,
            width: '100%',
            marginTop: marginXXS,
            padding: paddingXXS,
            zIndex: 1,
            borderRadius: borderRadiusSM,
            boxShadow: boxShadowSecondary,
          },
        },
      },

      '&-divide': {
        display: 'flex',
        borderBottom: `1px solid ${colorBorder}`,
        padding: `${marginXS}px 0`,
        justifyContent: 'space-between',
        gap: marginXS,
        flexWrap: 'wrap',

        [`${itemCls}:not(${itemCls}-feedback-layout-popover)`]: {
          marginBottom: '0 !important',

          [`${itemCls}-help`]: {
            position: 'absolute',
            fontSize: fontSizeSM,
            top: '100%',
            background: colorBgBase,
            width: '100%',
            marginTop: marginXXS,
            padding: paddingXXS,
            zIndex: 1,
            borderRadius: borderRadiusSM,
            boxShadow: boxShadowSecondary,
          },
        },
      },
    },
  };
});
